module.exports = __webpack_public_path__ + "arrow_down.19c2c9f1.jpg";